import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Icon',
    name: 'icon',
    type: FIELD_TYPES.INCIDENT_ICONS,
    defaultValue: 'question.png',
  },
]
